import { Injectable } from '@angular/core';
import {
  NativeDateAdapter,
  MatDateFormats
} from '@angular/material/core';

@Injectable()
export class StrictDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (value === null || value === '') {
      return null;
    }

    if (typeof value !== 'string') {
      return super.parse(value);
    }

    // MM/DD/YYYY format
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);

    if (!match) {
      return this.invalid();
    }

    // CORRECTED: match[1]=MM, match[2]=DD, match[3]=YYYY
    const month = Number(match[1]); // MM
    const day = Number(match[2]);   // DD
    const year = Number(match[3]);  // YYYY

    if (year < 1 || year > 9999) {
      return this.invalid();
    }

    // Month is 0-indexed in JavaScript Date (0-11)
    try {
      return this.createDate(year, month - 1, day);
    } catch {
      return this.invalid();
    }
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'MM/DD/YYYY') {
      if (!this.isValid(date)) {
        throw new Error('Invalid date');
      }

      // Format as MM/DD/YYYY
      const month = String(this.getMonth(date) + 1).padStart(2, '0'); // +1 because getMonth() is 0-indexed
      const day = String(this.getDate(date)).padStart(2, '0');
      const year = String(this.getYear(date)).padStart(4, '0');

      return `${month}/${day}/${year}`; // Use '/' separators
    }

    return super.format(date, displayFormat);
  }
}

export const STRICT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/DD/YYYY'
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    monthYearA11yLabel: {
      year: 'numeric',
      month: 'long'
    }
  }
};